/**
 * Legal pages (P6-01, blueprint §12.6). PLAIN-LANGUAGE DRAFTS written by engineering, NOT legal
 * advice. Before production: (1) fill the [bracketed] placeholders, (2) have them reviewed by a
 * lawyer, (3) set DRAFT to false. The refund policy is the founder's decision (docs/runbooks/billing-operations.md).
 */
export const DRAFT = false
export const EFFECTIVE = '18 Oktober 2026'
const OPERATOR = 'Alfacode.id (Kota Surabaya)'
const CONTACT = 'Email: alfacode.idn@gmail.com. WhatsApp: +62 851-8899-9994.'
// Decisions that belong to the owner of the product; they appear on several pages, so they are set once here.
const RETENTION = '30 hari'
const ANSWER_TIME = '7 hari kerja'

export type LegalDoc = { path: string; title: string; intro: string; sections: { heading: string; body: string[] }[] }

export const legalDocs: LegalDoc[] = [
  {
    path: 'syarat',
    title: 'Syarat penggunaan',
    intro: `GammaPOS adalah aplikasi kasir dan laporan untuk usaha jasa (barbershop, salon, cuci kendaraan) dan usaha makanan dan minuman, dijalankan oleh ${OPERATOR}.`,
    sections: [
      {
        heading: 'Akun dan penggunaan',
        body: [
          'Akun dibuat oleh pemilik usaha dengan nomor HP yang diverifikasi lewat kode SMS. Anda bertanggung jawab atas kerahasiaan kata sandi dan PIN, dan atas siapa yang Anda beri akses di device kasir.',
          'Satu cabang dilayani satu device kasir aktif pada satu waktu. Mengganti device dilakukan dari halaman Device.',
          'Anda tidak boleh memakai GammaPOS untuk kegiatan yang melanggar hukum, atau mencoba mengakses data usaha lain.',
        ],
      },
      {
        heading: 'Yang selalu berjalan',
        body: [
          'Mencatat transaksi, membatalkan transaksi, sesi kas, mencetak struk, mengirim data ke server, dan mengunduh seluruh data Anda tetap berjalan meskipun langganan berakhir.',
        ],
      },
      {
        heading: 'Langganan',
        body: [
          'Masa percobaan 30 hari. Setelah itu langganan berbayar diperlukan untuk laporan di web, komisi staf, unduhan CSV berformat, dan riwayat lengkap di device kasir.',
          'Setelah langganan berakhir ada masa tenggang 7 hari, lalu fitur tersebut dinonaktifkan sampai langganan diperpanjang. Satu bulan dihitung 30 hari; waktu baru ditambahkan di atas sisa waktu Anda.',
          'Pembayaran diproses oleh Midtrans. Kami tidak menyimpan nomor kartu atau data rekening Anda.',
          'Harga yang berlaku ditampilkan di halaman Langganan pada saat Anda membayar.',
        ],
      },
      {
        heading: 'Ketersediaan dan tanggung jawab',
        body: [
          'GammaPOS dirancang tetap bisa mencatat transaksi tanpa internet. Kami berusaha menjaga server tetap tersedia, tetapi tidak menjamin layanan tanpa gangguan.',
          'Angka laporan berasal dari transaksi yang dikirim device kasir. Transaksi yang belum terkirim belum masuk laporan; status pengiriman selalu terlihat di aplikasi.',
          'Tanggung jawab kami dibatasi sebesar biaya langganan yang Anda bayar untuk periode berjalan, sejauh diizinkan hukum.',
        ],
      },
      {
        heading: 'Perubahan syarat',
        body: ['Jika syarat berubah secara berarti, kami memberi tahu pemilik usaha lewat web sebelum perubahan berlaku.'],
      },
      { heading: 'Kontak', body: [CONTACT] },
    ],
  },
  {
    path: 'privasi',
    title: 'Kebijakan privasi',
    intro: `Halaman ini menjelaskan data apa yang disimpan ${OPERATOR} saat Anda memakai GammaPOS, untuk apa, dan berapa lama.`,
    sections: [
      {
        heading: 'Data yang kami simpan',
        body: [
          'Akun pemilik: nama, nomor HP, dan kata sandi (disimpan dalam bentuk acak satu arah, bukan teks asli).',
          'Verifikasi nomor HP: kami mengirim kode lewat SMS. Kode disimpan dalam bentuk acak, isi pesannya dihapus setelah terkirim, dan kode tidak bisa dipakai dua kali.',
          'Asal pendaftaran: label kampanye dari tautan yang Anda buka (misalnya sumber, kampanye, kode referral, dan halaman awal; untuk aplikasi, label dari tautan Google Play tempat aplikasi dipasang), bukan nama, alamat IP, atau data peramban Anda. Kode klik iklan hanya disimpan bila Anda setuju lewat pengaturan persetujuan di gammapos.id.',
          'Data usaha: nama usaha dan cabang, layanan dan harga, nama staf, aturan komisi, nama pengguna kasir dan PIN mereka (disimpan dalam bentuk acak satu arah).',
          'Transaksi: nomor struk, waktu, layanan, staf yang mengerjakan, jumlah, diskon, cara bayar, pembatalan beserta alasannya, dan sesi kas.',
          'Izin di device: aplikasi kasir meminta izin Bluetooth hanya untuk menyambung ke printer struk. Aplikasi tidak meminta lokasi, kontak, kamera, atau SMS.',
          'Data teknis: nama device kasir (misalnya "Galaxy S24 Ultra", atau nama yang Anda beri sendiri di pengaturan device), versi aplikasi, waktu terakhir sinkron, dan catatan perubahan penting (siapa mengubah harga, staf, komisi, atau membatalkan transaksi).',
          'Kami tidak menyimpan nama, nomor telepon, atau alamat pelanggan Anda; aplikasi ini tidak memintanya.',
        ],
      },
      {
        heading: 'Untuk apa',
        body: [
          'Menjalankan layanan: menampilkan laporan, menghitung komisi, mengganti device kasir, dan menagih langganan.',
          'Keamanan dan bantuan: mencatat perubahan penting dan membantu Anda ketika ada masalah.',
          'Kami tidak menjual data Anda dan tidak memakainya untuk iklan.',
        ],
      },
      {
        heading: 'Pihak lain yang terlibat',
        body: [
          'Midtrans memproses pembayaran langganan dan menerima data yang diperlukan untuk itu (nama, nomor HP pemilik, nilai pembayaran).',
          'Server kami berada di penyedia hosting di Singapura. Pelaporan kesalahan teknis (jika diaktifkan) tidak memuat isi transaksi maupun nomor HP.',
        ],
      },
      {
        heading: 'Berapa lama',
        body: [
          'Data disimpan selama akun aktif. Setelah akun ditutup, data transaksi disimpan ${RETENTION} agar Anda sempat mengunduhnya, lalu dihapus, kecuali yang wajib kami simpan menurut hukum (catatan pembayaran).',
          'Cadangan berkala dihapus mengikuti jadwal rotasi cadangan.',
        ],
      },
      {
        heading: 'Hak Anda',
        body: [
          'Anda dapat mengunduh semua data Anda kapan saja (Pengaturan → Unduh semua data), meminta koreksi, atau meminta penghapusan akun dan data. Ajukan lewat kontak di bawah; kami menjawab dalam ${ANSWER_TIME}. Cara lengkap ada di halaman Hapus akun dan data.',
        ],
      },
      { heading: 'Kontak', body: [CONTACT] },
    ],
  },
  {
    path: 'pengembalian-dana',
    title: 'Pengembalian dana dan pembatalan',
    intro: 'Kebijakan ini berlaku untuk langganan GammaPOS.',
    sections: [
      {
        heading: 'Pembatalan',
        body: [
          'Langganan tidak diperpanjang otomatis. Anda tidak perlu membatalkan apa pun: jika tidak membayar lagi, langganan berhenti pada tanggal berakhirnya.',
          'Sampai tanggal berakhir, semua fitur tetap bisa dipakai. Sesudahnya berlaku masa tenggang 7 hari, lalu fitur berbayar dinonaktifkan; pencatatan transaksi dan unduhan data tetap berjalan.',
        ],
      },
      {
        heading: 'Pengembalian dana',
        body: [
          'Waktu langganan yang sudah terpakai tidak dikembalikan dalam bentuk uang.',
          'Kami mengembalikan dana penuh bila terjadi pembayaran ganda, pembayaran yang berhasil tetapi langganan tidak aktif karena kesalahan kami, atau Anda mengajukan dalam 7 hari sejak pembayaran pertama dan belum memakai layanan berbayar. Ajukan lewat kontak di bawah dengan nomor pesanan (dimulai GP-).',
          'Dana dikembalikan lewat Midtrans ke cara bayar yang sama. Lama proses mengikuti bank atau dompet digital Anda.',
        ],
      },
      { heading: 'Kontak', body: [CONTACT] },
    ],
  },
  {
    path: 'data',
    title: 'Penyimpanan dan ekspor data',
    intro: 'Data usaha adalah milik Anda. Halaman ini menjelaskan bagaimana Anda mengambilnya dan apa yang terjadi padanya.',
    sections: [
      {
        heading: 'Ekspor kapan saja',
        body: [
          'Pengaturan → Unduh semua data memberi satu file zip berisi transaksi, rincian layanan, komisi, kas, layanan, staf, dan aturan komisi dalam CSV. Ini selalu tersedia, termasuk setelah langganan berakhir.',
          'File CSV memakai titik koma dan bisa dibuka di Excel dan Google Sheets.',
        ],
      },
      {
        heading: 'Jika device kasir hilang atau rusak',
        body: [
          'Transaksi yang sudah terkirim aman di server. Transaksi yang belum sempat terkirim hanya ada di device itu. Bila device masih bisa dinyalakan, buat ekspor darurat (terkunci, hanya tim GammaPOS yang bisa membukanya) dan kirim ke kami agar transaksinya dipulihkan ke laporan Anda.',
        ],
      },
      {
        heading: 'Penyimpanan',
        body: [
          'Data disimpan selama akun aktif dan mengikuti masa penyimpanan di Kebijakan privasi setelah akun ditutup.',
          'Server dicadangkan berkala; pemulihan dari cadangan tidak menghilangkan transaksi yang masih ada di device kasir, karena device mengirim ulang yang belum ada di server.',
        ],
      },
    ],
  },
  {
    path: 'hapus-akun',
    title: 'Hapus akun dan data',
    intro: `Anda dapat meminta ${OPERATOR} menghapus akun GammaPOS beserta data usahanya kapan saja. Halaman ini menjelaskan cara meminta, apa yang dihapus, dan berapa lama.`,
    sections: [
      {
        heading: 'Cara meminta',
        body: [
          'Di aplikasi kasir: buka menu, pilih Hapus akun (hanya untuk pemilik), isi nomor HP dan kata sandi akun, lalu tekan Hapus akun. Akun ditutup saat itu juga.',
          'Di web pemilik: buka Info cabang, pilih Hapus akun, isi kata sandi akun, beri tanda pada pernyataan, lalu tekan Hapus akun. Akun ditutup saat itu juga.',
          'Atau lewat email atau WhatsApp:',
          'Kirim permintaan lewat email atau WhatsApp di bagian Kontak. Tuliskan nomor HP akun, nama usaha, dan kata "hapus akun".',
          'Kami memastikan permintaan datang dari pemilik akun, misalnya dengan membalas ke nomor HP akun, sebelum menghapus apa pun.',
          `Kami menjawab dalam ${ANSWER_TIME}.`,
        ],
      },
      {
        heading: 'Sebelum menghapus',
        body: [
          'Unduh data Anda dulu: Pengaturan → Unduh semua data memberi satu file zip berisi transaksi, layanan, komisi, dan kas.',
          'Pastikan device kasir sudah mengirim semua transaksi (indikator "Semua transaksi sudah aman"). Transaksi yang belum terkirim tidak bisa kami pulihkan setelah akun dihapus.',
        ],
      },
      {
        heading: 'Apa yang dihapus',
        body: [
          'Akun pemilik, usaha dan cabang, layanan dan harga, staf dan komisi, pengguna kasir, transaksi dan sesi kas, dan data device kasir yang terdaftar.',
          `Data transaksi disimpan ${RETENTION} setelah akun ditutup agar Anda sempat mengunduhnya, lalu dihapus. Cadangan berkala dihapus mengikuti jadwal rotasi cadangan.`,
        ],
      },
      {
        heading: 'Apa yang tetap disimpan',
        body: ['Catatan pembayaran langganan yang wajib kami simpan menurut hukum. Catatan ini tidak memuat isi transaksi usaha Anda.'],
      },
      { heading: 'Kontak', body: [CONTACT] },
    ],
  },
]
